
export let metricMixin = {
	computed: {
		metricGoal() {
			let Goal = {
				INITIALIZE: false,
				EDIT_CONTACT: false,
				EDIT_DELIVERY: false,
				EDIT_PAY_SYSTEM: false,
				ADD_PROMO_CODE: false,
				PAY_ORDER: false,
				SAVE_ORDER: false
			};

			if("Y" !== this.params.USE_YM_GOALS)
			{
				return Goal;
			}

			if(this.params.hasOwnProperty('YM_GOALS_EDIT_CONTACT'))
				Goal.EDIT_CONTACT = this.params.YM_GOALS_EDIT_CONTACT;
			if(this.params.hasOwnProperty('YM_GOALS_EDIT_DELIVERY'))
				Goal.EDIT_DELIVERY = this.params.YM_GOALS_EDIT_DELIVERY;
			if(this.params.hasOwnProperty('YM_GOALS_EDIT_PAY_SYSTEM'))
				Goal.EDIT_PAY_SYSTEM = this.params.YM_GOALS_EDIT_PAY_SYSTEM;
			if(this.params.hasOwnProperty('YM_GOALS_SAVE_ORDER'))
				Goal.SAVE_ORDER = this.params.YM_GOALS_SAVE_ORDER;
			if(this.params.hasOwnProperty('YM_GOALS_SAVE_ORDER'))
				Goal.PAY_ORDER = this.params.YM_GOALS_PAY_ORDER;
			if(this.params.hasOwnProperty('YM_GOALS_ADD_PROMO_CODE'))
				Goal.ADD_PROMO_CODE = this.params.YM_GOALS_ADD_PROMO_CODE;

			return Goal;
		}
	}
}

export default metricMixin;